import './Navbar.css';

function Newsg(){
    return(
       <>
         <div id='bigdiv'>
                <div id='bigdivsmalls'>
                    <div> <img src="https://imgnew.outlookindia.com/uploadimage/library/16_9/16_9_5/Cover_1663842316.webp" alt="" />
                    </div>

                    <div id='bigdivsmalls-2'>
                        <div><h1>Ayodhya Settled, Focus Is Back On Places Of Worship Act, 1991</h1></div>

                        <div id='bigdivsmalls-2a'>
                            <div><p>With the tide of majoritarian appeasement, fuelled by the ruling political establishment, there are efforts now to even exempt the Gyanvapi mosque-Shringar Gauri dispute in Varanasi from the ambit of the Places of Worship (Special Provisions) Act, 1991. The Academic Mobility Programme evades the responsibility of safeguarding the careers of over 20,000 medical students who returned from war-ravaged Ukraine, say some education counsellors  .When one party is God, it cannot be said that both parties are at the same level, because with God, religious sentiments of people are involved</p></div>
                            <div>
                                <ul>
                                    <li>
                                        Though the objective of Places of Worship Act to discourage any retrogression into communal fault .
                                    </li>
                                    <li>

                                        The decline of industry and businesses in Hubballi, once a thriving centre for processing.

                                    </li>
                                    <li>
                                        Bitcoin (BTC) fell by 6.4 per cent to $18,932, while Ethereum (ETH) was down by 6.6 per cent to $1,293 on Wednesday evening.
                                    </li>
                                    <li>

                                        With more and more governments showing interest in central bank digital coins (CBDCs), we explore how these coins might impact your life and whether the technology is viable.

                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div id='div-3rd'>
                        <div>
                            <img src="https://imgnew.outlookindia.com/uploadimage/library/16_9/16_9_5/IMAGE_1663815712.webp" alt="" />
                            <h2>
                                Ayodhya And Hubballi: The Cities That Defined The Course Of Indian Politics
                            </h2>
                            <p>If the Ram Temple movement established the saffron outfit in the Hindi belt, the Hubballi campaign catapulted it to power in the state</p>
                            <ul>
                                <li>It started a while ago when I noticed my Pratiksha seemed restless. As I held her, I could feel her</li>
                            </ul>
                        </div>
                        <div id="div3rd-2">
                            <div>
                                <h2>
                                    The Popular Front of India was formed in 2006 and several of its founders and cadres once belonged to the terrorist.
                                </h2>

                            </div>
                            <div id='div3rd-2a'>
                                 <div>
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ab nostrum similique molestias tenetur ducimus laborum quod illum aut ipsa provident, amet veritatis libero   </p>
                                 </div>
                                 <div><img src="https://imgnew.outlookindia.com/uploadimage/library/16_9/16_9_5/IMAGE_1663764219.webp" alt="" /></div>
                            </div>
                            <div>
                                <ul>
                                    <li>
                                    Now that the Ayodhya dispute has been settled in favour of the Hindu side, the focus is back on the Places of Worship Act, 1991, which threatens to open a Pandora’s box. Groups representing Hindu gods are now eyeing waqf lands, thereby threatening the secular character of the country.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div id='lastdiv'>
                     <div>
                       <img src="https://imgnew.outlookindia.com/uploadimage/library/16_9/16_9_5/IMAGE_1663775032.webp" alt="" />
                     </div>
                     <div id='lastdiv2h'>
                            <h2>
                                    Muslim Front of India was formed in 2006 and several of its founders .
                            </h2>
                            <p>
                            PFI came into being in response to violence against Muslims. Political silence on it only helped the fundamentalist outfit grow in coastal Karnataka.When one party is God, it cannot be said that both parties are at the same level, because with God, religious sentiments of people are involved.The incident happened just after Richarlison scored Brazil.
                            </p>
                     </div>
                     <div>
                            <h2>
                            There are about 50 lakh central government employees and over 61 lakh pensioners
                            </h2>
                            <p>
                            When one party is God, it cannot be said that both parties are at the same level, because with God, religious sentiments of people are involved.
                            The recent death of six prison escapees in Meghalaya drew the world's attention to the unique names of the Khasi people of India and the complex history and...
                            </p>
                     </div>
                     <div>
                        <img src="https://imgnew.outlookindia.com/uploadimage/library/16_9/16_9_1/IMAGE_1664004962.webp" alt="" />
                     </div>
                     <div>
                        <h2>
                        Uttarakhand Receptionist Murder: No Rape Evidence But Doubts Over 'VIP Guest', Overnight Demolition
                        </h2>
                        <p>
                        The main accused in the killing of 19-year-old Ankita Bhandari and owner of the Vanantara resort, Pulkit Arya, is the son of former Bharatiya Janata Party (BJP) leader Vinod Arya, who was expelled by the party when his son's name cropped up in the case.
                        </p>
                        <ul>
                                    <li>
                                    Ukraine War: According to Russia-installed election officials
                                    </li>
                        </ul>
                     </div>
                </div>

            </div>
       </>
    )
}

export default Newsg